<template>
  <div class="employDetail">
    <el-form :model="formData" size="mini" label-width="180px" class="form-horizontal detail-form detail-text-form" style="margin-bottom: 10px;">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="基本信息" name="1">
          <div class="form-detail-container">
            <el-row :gutter="20" v-if="isManager==false" >
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">经营者名称：</span>
                  <span class="detail-desc">{{formData.realManagerName}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">门店：</span>
                  <span class="detail-desc">{{formData.storeName}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">房源编码：</span>
                  <span class="detail-desc">{{formData.roomCode}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">房源名称：</span>
                  <span class="detail-desc">{{formData.roomName}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">房间号：</span>
                  <span class="detail-desc">{{formData.roomNumber}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">房型：</span>
                  <span class="detail-desc">{{formData.roomTypeName}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">出租类型：</span>
                  <span class="detail-desc">{{formData.rentTypeName}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">经营面积(㎡)：</span>
                  <span class="detail-desc">{{formData.roomSize}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">房屋间数：</span>
                  <span class="detail-desc">{{formData.bedroomNum}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">床位数：</span>
                  <span class="detail-desc">{{formData.bedNum}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="detail-item">
                  <span class="detail-label">宜住人数：</span>
                  <span class="detail-desc">{{formData.maxLiveNum}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="detail-item">
                  <span class="detail-label">归属省市区：</span>
                  <span class="detail-desc">{{`${formData.province}${formData.city}${formData.region}`}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="detail-item">
                  <span class="detail-label">房源地址：</span>
                  <span class="detail-desc">{{formData.addrDetail}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">街道：</span>
                  <span class="detail-desc">{{formData.streetOffice}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">社区：</span>
                  <span class="detail-desc">{{formData.neighborCmm}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">派出所：</span>
                  <span class="detail-desc">{{formData.policeStationName}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">房屋编码：</span>
                  <span class="detail-desc">{{formData.addrCode}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="detail-item">
                  <span class="detail-label">简要情况：</span>
                  <span class="detail-desc">{{formData.briefInfo}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="detail-item">
                  <span class="detail-label">照片：</span>
                  <div class="detail-desc detail-img">
                    <template v-for="(itemUrl,index) in formData.photoUrl" :key="'ii6i_w'+index">
                      <el-image
                        style="width: 100px; height: 100px"
                        fit="cover"
                        :src="itemUrl"
                        :preview-src-list="[itemUrl]"
                        z-index="99999"
                      >
                      </el-image>
                    </template>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item title="产权信息" name="2">
          <div class="form-detail-container">
            <div v-show="!formData.ownerCompany || formData.ownerCompany=='--'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">产权人：</span>
                    <span class="detail-desc">{{formData.ownerName}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">联系电话：</span>
                    <span class="detail-desc">{{formData.ownerPhone}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">国籍：</span>
                    <span class="detail-desc">{{formData.ownerCountryName}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">外文姓：</span>
                    <span class="detail-desc">{{formData.ownerLastName}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">外文名：</span>
                    <span class="detail-desc">{{formData.ownerFirstName}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">证件种类：</span>
                    <span class="detail-desc">{{formData.ownerCertTypeName}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">证件号码：</span>
                    <span class="detail-desc">{{formData.ownerCertCode}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">不动产权证书编号：</span>
                    <span class="detail-desc">{{formData.realStateCode}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-show="formData.ownerCompany && formData.ownerCompany!='--'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">产权单位：</span>
                    <span class="detail-desc">{{formData.ownerCompany}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">联系电话：</span>
                    <span class="detail-desc">{{formData.ownerPhone}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">社会信用代码：</span>
                    <span class="detail-desc">{{formData.ownerCreditCode}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">不动产权证书编号：</span>
                    <span class="detail-desc">{{formData.realStateCode}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="detail-item">
                  <span class="detail-label">附件：</span>
                  <div class="detail-box" style="flex-wrap: wrap;text-align: center ">
                    <template v-for="(itemUrl,index) in formData.attachIdUrl" :key="'iii_'+index">
                      <el-image
                        style="width: 100px; height: 100px"
                        fit="cover"
                        :src="itemUrl"
                        :preview-src-list="[itemUrl]"
                        z-index="99999"
                      ></el-image>
                    </template>
                    {{(!formData.attachIdUrl||formData.attachIdUrl.length==0)?'--':''}}
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item title="设备信息" name="4">
          <div class="form-detail-container">
            <el-row :gutter="20">
              <el-col :span="12">
                <!-- ??? -->
                <div class="detail-item">
                  <span class="detail-label">智能门锁：</span>
                  <span class="detail-desc">{{formData.cqrXm}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">型号：</span>
                  <span class="detail-desc">{{formData.cqrXm}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">智能门铃：</span>
                  <span class="detail-desc">{{formData.cqrXm}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">型号：</span>
                  <span class="detail-desc">{{formData.cqrXm}}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item title="审核信息" name="1">
          <div class="check-containor">
            <el-radio v-model="formData.reviewStatus" label="2">通过</el-radio>
            <el-radio v-model="formData.reviewStatus" label="3">不通过</el-radio>
            <el-input class="check-reason" type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="请输入审核理由" v-model="formData.reviewInfo"></el-input>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div style="text-align: center;padding: 20px;width: 100%;">
        <el-button class="submit-btn" icon="CircleCheck" @click="handleSave(0)">确定</el-button>
        <el-button class="cancel-btn" icon="CircleClose" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import Vue from 'vue';
  import RTable from '@/components/common/RTable'
  import tableMix from '@/components/common/tableListMixin.js'
  import moment from 'moment'
  import { mapActions, mapGetters ,mapState} from 'vuex'
export default {
  name: 'employeeDetail',
  mixins: [tableMix],
  components: {
    RTable },
  data() {
    let detailKeys = ['reviewStatus','reviewInfo','realManagerName','storeName','roomCode','roomName','roomNumber','roomTypeName',
      'rentTypeName','roomSize','bedroomNum','bedNum','maxLiveNum','province','city','region',
      'addrDetail','xpoint','ypoint','streetOffice','neighborCmm','policeStationName','addrCode',
      'briefInfo','photoUrl','ownerName','ownerPhone','ownerCountryName','ownerLastName','ownerFirstName',
      'ownerCertTypeName','ownerCertCode','realStateCode','ownerCompany','ownerPhone','ownerCreditCode','realStateCode',
      'attachIdUrl','lockDeviceCode','lockDeviceModel','bellDeviceCode','bellDeviceModel'
    ]
    let formData = {}
    detailKeys.map((key)=>{
      formData[key] = ''
    })
    return {
      activeNames:['1','2','3','4','5','6'],
      item:{value:'aaa'},
      detailKeys:detailKeys,
      formData:formData,
      userInfo: {},
    }
  },
  computed: {
    ...mapState({
      user: state => state.common.user
    }),
    // 是否为房东（ 4经营者、 5管家）
    isManager() {
      if (this.userInfo.userType == 5 || this.userInfo.userType == 4) return true
      return false
    }
  },
  props: {
    selOptions: {
      type: Object,
      default:{czlx:[],wyfptdwbm:[],cqrGjdm:[],cqrCyzjdm:[],jyzbm:[]}
    },
    detailModal: { type: Boolean, default: false },
    detailData: { type: Object, default: {} },
  },
  watch:{
    detailModal:{
      immediate: true,
      handler: function(to){
        if(to===false){
          return false
        }

        this.detailKeys.forEach((key)=>{
          this.formData[key] = this.detailData[key] ? this.detailData[key]:'--'
        })
        this.formData.reviewStatus = '2'
        this.formData.reviewInfo = ''
        console.log(this.formData,'ffff')
      }
    }
  },
  created() {
    let userInfo = localStorage.getItem('user')
    this.userInfo = userInfo ? JSON.parse(userInfo) : {}
  },
  methods: {
    //取消
    handleCancel(){
      this.$emit('closeModel')
    },
    //保存与发布
    handleSave(type){
      this.saveLoading = true
      this.doSave(type)
    },
    doSave(type){
      if(this.formData.reviewStatus=='-1' && this.formData.reviewInfo.trim()==''){
        this.$message.error('请填写审核说明！')
        return false
      }

      let url = 'SAAS.ROOM_EDIT_CHECK'
      let paramData = {id:this.detailData.id}
      paramData.reviewStatus = this.formData.reviewStatus
      //paramData.examineTime = moment().format('YYYY-MM-DD HH:mm:ss')
      paramData.reviewInfo = this.formData.reviewInfo || ''
      //paramData.examineUid = this.user.id


      let params = {...paramData}

      this.fetchData({url:url, method: 'post', params:params,timeout:0, isLoading:false, flag:true ,headers:{'Content-Type':'application/json'}}).then((res)=>{
        if(res.code==200){
          this.$message.success('操作成功！')
          this.$emit('submitSuccess')
        }else{
          this.$message.error(res.msg||'操作失败！')
        }
        this.saveLoading = false
      }).catch((err)=>{
        this.$message.error('操作失败！')
        this.saveLoading = false
      }).finally (()=>{
        this.saveLoading = false
      })
    },
  }
}
</script>

<style lang="less" scoped>
.detail-form{
  display: flex;
  flex-wrap: wrap
}
.form-detail-container {
  padding: 15px 20px;
  background-color: #f5f5f5;
  border-radius: 3px;
}
.detail-item {
  display: flex;
  margin-bottom: 4px;
  .detail-label {
    color: #959697;
  }
  .detail-desc {
    flex: 1;
    text-align: justify;
  }
  .detail-img {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}
.el-collapse{
  width: 100%;
}
.check-containor {
  margin-left: 30px;
}
</style>
<style lang="less" scoped>
  .el-form-item{
    width: 50%;
  }
  .el-form-item.rowItem {
    width: 100% !important;
  }
  .detail-form{
     display: flex;
     flex-wrap: wrap
   }
   .detail-box{
     display: flex;
     flex-wrap: wrap;
     width:100%;
   }
   .ownerDiv{
     width: 100%;
   }
   .el-image{
     margin-right: 15px;
   }

  .el-collapse{
    width: 100%;
  }
  #locate-map-detail {
    width: 100%;
    height: 200px;
  }
</style>
